import {
  IUseTreatmentWithConfigResult,
  useTreatmentWithConfig,
} from '@splitsoftware/splitio-react'

import { useSeller } from '@/contexts/seller'
import { FeatureToggle } from '@/resources/enums/featureToggle'
import { SELLER_DATA } from '@/resources/utils'

type Props = {
  splitName: string
  attributes?: object
  includeLoadingState?: boolean
  includeConfig?: boolean
}

type StoredSellerData = {
  seller?: {
    id?: number | string
    address?: {
      provinceCode?: string
      city?: string
    }
  }
}

export default function useFeatureToggle({
  splitName,
  attributes = {},
  includeLoadingState = false,
  includeConfig = false,
}: Props) {
  const { sellerData } = useSeller()
  const sellerDataFromStorage: StoredSellerData = JSON.parse(
    localStorage.getItem(SELLER_DATA) ?? '{}'
  ) as StoredSellerData

  const pocId =
    sellerData?.seller?.id ?? sellerDataFromStorage?.seller?.id ?? -1
  const province =
    sellerData?.seller?.address?.provinceCode ??
    sellerDataFromStorage?.seller?.address?.provinceCode ??
    ''
  const city =
    sellerData?.seller?.address?.city ??
    sellerDataFromStorage?.seller?.address?.city ??
    ''

  const {
    treatment: { treatment = '', config = null },
    isReady = false,
  }: IUseTreatmentWithConfigResult = useTreatmentWithConfig({
    name: splitName,
    attributes: { ...attributes, poc_id: pocId, province, city },
    splitKey: process.env.SPLIT_IO_KEY,
  })

  if (includeLoadingState && (!pocId || !isReady)) {
    return FeatureToggle.LOADING
  }

  if (includeConfig && isReady) {
    return { treatment, config }
  }

  return isReady ? treatment : FeatureToggle.OFF
}
